import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from '../../../services/message.service';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { ContascorrentesService } from '../../../services/contascorrentes.service';
import { getErrorMessage, setFormValue } from '@utils';
import { firstValueFrom } from 'rxjs';
import swal from 'sweetalert2';
import { AilosApiAmbiente } from '../../../model/AilosApiAmbiente';

@Component({
  selector: 'app-configurar-integracao-ailos',
  templateUrl: './configurar-integracao-ailos.component.html',
  styleUrls: ['./configurar-integracao-ailos.component.css']
})
export class ConfigurarIntegracaoAilosComponent extends ModalCadastroComponent implements OnInit {
  AilosApiAmbiente = AilosApiAmbiente; // Para uso no template
  @ViewChild('modal', { static: true }) modal;
  contaCorrenteId = null;
  cancelarVerificacaoApi = false;

  form: FormGroup = new FormGroup({
    apiAtiva: new FormControl(null),
    ailosBolePix: new FormControl(null),
    ambiente: new FormControl(null),
  });

  constructor(
    public messageService: MessageService,
    private contasCorrentesService: ContascorrentesService,
  ) {
    super();
  }

  show() {
    this.modal.show();
  }

  onClose() {
    this.closed.emit();
  }

  ngOnInit() {
    this.contaCorrenteId = this.prop.contaCorrenteId;
    this.carregarDados();
  }

  async carregarDados() {
    try {
      this.loading['dados'] = true;

      const res = await firstValueFrom(this.contasCorrentesService.buscarConfiguracaoApiAilos(this.contaCorrenteId));
      setFormValue(this.form, res);
      
      this.loading['dados'] = false;
    } catch (err) {
      this.messageService.error(getErrorMessage(err), 8000);
      this.closed.emit();
    }
  }

  ativarApiAilos(ambiente: AilosApiAmbiente) {
    const msg = ambiente === AilosApiAmbiente.HOMOLOGACAO
      ? 'Será aberta uma janela de login seguro do sistema Ailos, insira os dados da conta de Homologação que você recebeu da Ailos.<br><br>'
      : 'Por exigência do banco, será aberta uma janela de login seguro do sistema Ailos.<br>'
        + 'Insira os dados e a senha alfanumérica da conta que emitirá os boletos.<br><br>'
        + 'Essa ação libera a emissão de boletos através da API de Cobrança.<br><br>';

    swal({
      html: msg + 'A janela será fechada automaticamente ao identificar o acesso.',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ativar',
      cancelButtonText: 'Cancelar',
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        await this.solicitarLoginAilos(ambiente);
        return {};
      },
      allowOutsideClick: () => !swal.isLoading()
    });
  }

  async solicitarLoginAilos(ambiente: AilosApiAmbiente) {
    try {
      const urlLogin = await firstValueFrom(this.contasCorrentesService.gerarUrlLoginAilos(this.contaCorrenteId, ambiente));
      if (urlLogin) {
        const width = 600;
        const height = 700;
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);

        const janela = window.open(
          urlLogin,
          'Autenticação Ailos',
          `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=yes`
        );

        this.cancelarVerificacaoApi = false;
        while (!this.cancelarVerificacaoApi) {
          await this.sleep(5000);

          if (janela.closed || this.cancelarVerificacaoApi) {
            this.cancelarVerificacaoApi = true;
            break;
          }

          const autenticado = await firstValueFrom(this.contasCorrentesService.verificarLoginAilos(this.contaCorrenteId, ambiente));

          if (autenticado) {
            janela.close();
            this.cancelarVerificacaoApi = true;
            this.form.get('apiAtiva').setValue(true);
            this.messageService.success('Integração ativada.', 5000);
            break;
          }
        }

        this.carregarDados();
      }
    } catch (error) {
      this.messageService.error(getErrorMessage(error), 8000);
    }
  }

  sleep(ms) {
    return new Promise((res, _) => {
      setTimeout(() => res(true), ms);
    });
  }

  ngOnDestroy() {
    this.cancelarVerificacaoApi = true;
  }

  async desativarApiAilos() {
    await swal({
      title: 'Deseja desativar a API da Ailos para esta conta corrente?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Desativar',
      cancelButtonText: 'Cancelar',
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          await firstValueFrom(this.contasCorrentesService.desativarApiAilos(this.contaCorrenteId));
          this.form.get('apiAtiva').setValue(false);
          this.messageService.success('API desativada', 8000);
          this.carregarDados();
        } catch (error) {
          this.messageService.error(getErrorMessage(error), 8000);
        }

        return {};
      },
      allowOutsideClick: () => !swal.isLoading()
    });
  }

  async salvarConfiguracaoApiAilos() {
    try {
      this.loading['salvarConfiguracaoApiAilos'] = true;
      await firstValueFrom(this.contasCorrentesService.salvarConfiguracaoApiAilos(this.contaCorrenteId,
        this.form.get('ailosBolePix').value));

      this.messageService.success('As configurações foram salvas com sucesso.', 5000);
      this.closed.emit();
    } catch (err) {
      this.messageService.error(getErrorMessage(err), 8000);
    } finally {
      this.loading['salvarConfiguracaoApiAilos'] = false;
    }
  }
}
